/** Mirrors `buildRazaEventBody` raza-backed branch in `google-calendar.service.ts`. */
export function razaEventHostDisplay(hostName: unknown, hostItsNo: unknown): string {
  const n = typeof hostName === "string" ? hostName.trim() : "";
  const i = typeof hostItsNo === "string" ? hostItsNo.trim() : "";
  const out = (n || i || "Host").trim();
  return out || "Host";
}

/**
 * Calendar `eventLabel`: stored `title` when set; otherwise booking purpose **name** when provided;
 * otherwise the same default as Google Calendar (`"Raza event"`).
 */
export function razaEventLabelFromTitle(title: unknown, purposeName?: unknown): string {
  const t = typeof title === "string" ? title.trim() : "";
  if (t) return t;
  const p = typeof purposeName === "string" ? purposeName.trim() : "";
  return (p || "Raza event").trim() || "Raza event";
}

export function razaEventCalendarBaseTitle(
  title: unknown,
  hostName: unknown,
  hostItsNo: unknown,
  purposeName?: unknown
) {
  const eventLabel = razaEventLabelFromTitle(title, purposeName);
  const hostDisplay = razaEventHostDisplay(hostName, hostItsNo);
  return `${eventLabel} - ${hostDisplay}`;
}
